// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"c2","header":"c3","title":"c4","subHeader":"c5","footer":"c6"};